import {
	FETCH_CALL_STATUS_LIST,
	IS_LOADING,
	FETCH_IVR_FLOW_NAME,
	FETCH_CALL_TYPE_LIST,
	FETCH_CALL_TYPE_SOURCE_LIST,
	FETCH_CALL_SOURCE,
	FETCH_REPORT_LIST,
	FETCH_CAMPAIGN_NAMES,
	FETCH_REPORT_STATUS_LIST,
	FETCH_NEW_REPORT_LIST,
	FETCH_FILTERED_NEW_LIST,
	FETCH_SPEECH_STATUS_LIST,
	FETCH_SPEECH_CALL_TYPE_LIST,
	FETCH_HANGUP_STATUS_LIST,
	FETCH_SYSTEM_DISPO_LIST,
} from '../actions/analyticsReport.action';
import { AnalyticsReportReducer } from '../models/analyticsReport.interface';

const initialState: AnalyticsReportReducer = {
	hangupStatusList: {},
	systemDispoList: {},
	callStatusList: {},
	isLoading: false,
	isError: false,
	errorMessage: '',
	ivrFlowNameList: [],
	callTypeList: {},
	callTypeSourceList: {},
	callSourceList: {},
	reportList: [],
	campaignNameList: {},
	reportStatusList: {},
	total: -1,
	totalListReports: 0,
	speechStatusList: {},
	speechCallTypeList: {},
};

const analyticsReportReducer = (
	state: AnalyticsReportReducer = initialState,
	action: any
): AnalyticsReportReducer => {
	switch (action.type) {
		case IS_LOADING:
			return {
				...state,
				isLoading: action.payload,
			};
		case FETCH_CALL_STATUS_LIST:
			return {
				...state,
				callStatusList: action.payload.res,
				isError: false,
			};
		case FETCH_SPEECH_STATUS_LIST:
			return {
				...state,
				speechStatusList: action.payload.res,
				isError: false,
			};
		case FETCH_HANGUP_STATUS_LIST:
			return {
				...state,
				hangupStatusList: action.payload.res,
				isError: false,
			};
		case FETCH_SYSTEM_DISPO_LIST:
			return {
				...state,
				systemDispoList: action.payload.res,
				isError: false,
			};
		case FETCH_IVR_FLOW_NAME:
			return {
				...state,
				ivrFlowNameList: action.payload.res,
				isError: false,
			};
		case FETCH_CALL_TYPE_LIST:
			return {
				...state,
				callTypeList: action.payload.res,
				isError: false,
			};
		case FETCH_SPEECH_CALL_TYPE_LIST:
			return {
				...state,
				speechCallTypeList: action.payload.res,
				isError: false,
			};
		case FETCH_CALL_TYPE_SOURCE_LIST:
			return {
				...state,
				callTypeSourceList: action.payload.res,
				isError: false,
			};
		case FETCH_CALL_SOURCE:
			return {
				...state,
				callSourceList: action.payload.res,
				isError: false,
			};
		case FETCH_CAMPAIGN_NAMES:
			return {
				...state,
				campaignNameList: action.payload.res,
				isError: false,
			};
		case FETCH_REPORT_LIST:
			return {
				...state,
				reportList: [...state.reportList, ...action.payload.res],
				totalListReports: action.payload.total,
				isError: false,
			};
		case FETCH_NEW_REPORT_LIST:
			return {
				...state,
				reportList: action.payload.res,
				total: action.payload.total,
				totalListReports: action.payload.total,
				isError: false,
			};
		case FETCH_FILTERED_NEW_LIST:
			return {
				...state,
				reportList: action.payload.res,
				totalListReports: action.payload.total,
				isError: false,
			};
		case FETCH_REPORT_STATUS_LIST:
			return {
				...state,
				reportStatusList: action.payload.res,
				isError: false,
			};
		default:
			return state;
	}
};

export default analyticsReportReducer;
